export default __webpack_public_path__ + "static/media/sac_bbq.b4aa1ffc.jpeg";